import React from "react";
import { Navbar, NavbarBrand } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import ConfigActions from "stores/config/ConfigAction";
import UtenteAction from "stores/utente/UtenteAction";
import NavigationUtility from "utilities/NavigationUtility";
import logoLinks from "../../../assets/img/linksLogo.png";
import logoBanca from "../../../assets/img/logo_banca.svg";
import IAction from "../../../models/IAction";
import IStore from "../../../models/IStore";
import BaseHeaderAutoComplete from "../base-form/BaseHeaderAutoComplete";
import BaseLabel from "../base-form/BaseLabel";
import LoadingIndicator from "../loading-indicator/LoadingIndicator";
import HeaderUtente from "./components/HeaderUtente";
import FormatUtility from "utilities/FormatUtility";
import HeaderNotifiche from "./components/HeaderNotifiche";
import HeaderNote from "./components/HeaderNote";
import ConfigAction from "stores/config/ConfigAction";
import CercaHeaderAction from "../../../stores/cerca-header/CercaHeaderAction";
import SearchModel from "../../../stores/cerca-header/models/SearchModel";
import { CercaHeaderRequest } from "../../../stores/cerca-header/CercaHeaderEffect";
import RouteEnum from "constants/RouteEnum";
import CercaAction from "stores/ricerca/CercaAction";
import BaseHeaderOptionModel from "stores/shared/models/BaseHeaderOptionModel";
import EstimatesModel from "stores/cerca-header/models/EstimatesModel";
import SimulationsResultModel from "stores/cerca-header/models/SimulationsResultModel";
import SimulazioneStepTwoFormModel from "stores/simulazione/models/SimulazioneStepTwoFormModel";
import SimulazioneStepThreeFormModel from "stores/simulazione/models/SimulazioneStepThreeFormModel";
import { ISimulateRequest } from "stores/simulazione/SimulazioneEffect";
import SimulazioneAction from "stores/simulazione/SimulazioneAction";
import LookUpAction from "stores/lookup/LookUpAction";
import DateFormatEnum from "constants/DateFormatEnum";
import environment from "environment";
import SimulazioneStepOneFormModel from "stores/simulazione/models/SimulazioneStepOneFormModel";
import moment from "moment";
import SimulazioneModel from "stores/simulazione/models/SimulazioneModel";
import CercaDettalgioSimulazioneModel from "stores/ricerca/models/CercaDettalgioSimulazioneModel";
import CercaDettalgioPreventivoModel from "stores/ricerca/models/CercaDettalgioPreventivoModel";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import StepsUtility from "utilities/StepsUtility";
import EstimateAction from "stores/estimate/EstimateAction";
import CanaliModel from "../../../stores/lookup/models/CanaliModel";

interface IProps {}
interface IState {
    readonly isNavigating: boolean;
    readonly token: string;
    readonly embeddedMode: boolean;
}
interface IStateToProps {
    readonly isRequesting: boolean;
    readonly isLogged: boolean;
    readonly pathname: string;
    readonly searchHeader: SearchModel;
    readonly form: BaseHeaderOptionModel;
    readonly embeddedMode: boolean;
    readonly formValuesStep2: SimulazioneStepTwoFormModel;
    readonly dettaglioSimulazione?: CercaDettalgioSimulazioneModel;
    readonly dettaglioPreventivo?: CercaDettalgioPreventivoModel;
    readonly resumedSimulazione: SimulazioneModel;
    readonly canali: CanaliModel[];
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: false,
    // isRequesting: selectRequesting(state, [UtenteAction.REQUEST_UTENTE_GET]),
    isLogged: state.utente.profilo.isLogged,
    pathname: state.router.location.pathname,
    searchHeader: state.cercaHeader.search,
    form: state.cercaHeader.form,
    embeddedMode: state.config.embeddedMode,
    formValuesStep2: state.simulazione.formStep2,
    dettaglioSimulazione: state.cerca.cercaDettalgioSimulazioneModel,
    dettaglioPreventivo: state.cerca.dettalgioPreventivoModel,
    resumedSimulazione: state.simulazione.resumedSimulazione,
    canali: state.lookup.canali,
});

class Header extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            isNavigating: false,
            token: "",
            embeddedMode: false,
        };
    }
    public componentDidMount() {
        const isIE: boolean = !!window.MSInputMethodContext && !!document.DOCUMENT_NODE;
        this.props.dispatch(ConfigActions.setIsIE(isIE));
        if (navigator.userAgent.indexOf("Safari") === -1 && navigator.userAgent.indexOf("Chrome") !== -1) {
            this.props.dispatch(ConfigActions.setIsSafari(true));
        }
        // this.loadData();
    }

    private loadData = async () => {
        if (this.props.isLogged) {
            await this.props.dispatch(UtenteAction.utenteGet());
        }
    };

    public componentDidUpdate(
        prevProps: Readonly<IProps & IStateToProps & DispatchProp<IAction<any>>>,
        prevState: Readonly<IState>,
        snapshot?: any
    ): void {
        if (prevProps.isLogged === false && this.props.isLogged === true) {
            // this.loadData();
        }
    }

    private redirectToPage = (page: string) => {
        NavigationUtility.redirectToPage(page);
    };

    private addLoader = async () => {
        this.setState({ isNavigating: true });
    };

    private removeLoader = async () => {
        this.setState({ isNavigating: false });
    };

    private onChangeHandler = async (value: BaseHeaderOptionModel) => {
        let link = "";
        let id = "";
        let idEstimate;
        let idEstimateRequest;
        debugger;
        await this.props.dispatch(CercaHeaderAction.setForm(value));
        await this.props.dispatch(ConfigAction.setSearchOnFocus(false));

        if (value) {
            link = value.href!;
            id = link.substring(link.lastIndexOf("/") + 1);

            idEstimate = value.info?.idEstimate;
            idEstimateRequest = value.info?.idEstimateRequest;
        }

        if (link.indexOf("FindSimulation") > -1) {
            this.props.dispatch(ConfigAction.setSearchOnFocus(true));
            this.addLoader();
            await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(Number(id)));
            await this.props.dispatch(SimulazioneAction.resumeSimulation(Number(id)));
            await this.props.dispatch(CercaAction.resetDettaglioPreventivo());
            await this.props.dispatch(EstimateAction.resetPreventivo());
            await this.handleSimulazioneRedirect();
            this.props.dispatch(ConfigAction.setSearchOnFocus(false));
            this.removeLoader();
        } else if (link.indexOf("FindEstimate") > -1) {
            this.props.dispatch(ConfigAction.setSearchOnFocus(true));
            this.addLoader();
            await this.props.dispatch(
                CercaAction.dettaglioPreventivoGet(Number(idEstimate), Number(idEstimateRequest))
            );
            await this.handleDettaglio();
            await this.handlePreventivoRedirect();
            this.props.dispatch(ConfigAction.setSearchOnFocus(false));
            this.removeLoader();
        }
    };

    private handleDettaglio = async () => {
        const { dettaglioPreventivo } = this.props;

        await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(Number(dettaglioPreventivo?.idSimulation)));
        await this.props.dispatch(SimulazioneAction.resumeSimulation(Number(dettaglioPreventivo?.idSimulation)));
    };

    private handlePreventivoRedirect = async () => {
        const { formValuesStep2, canali, dettaglioSimulazione, dettaglioPreventivo, resumedSimulazione } = this.props;
        if (dettaglioSimulazione?.idAgent) {
            this.props.dispatch(LookUpAction.canaliGet(Number(dettaglioSimulazione?.idAgent)));
        }
        if (dettaglioSimulazione && dettaglioPreventivo && resumedSimulazione) {
            const step1FormValues = StepsUtility.setStep1FormValues(
                dettaglioSimulazione,
                resumedSimulazione,
                canali,
                dettaglioPreventivo
            );
            // const step1FormValues = new SimulazioneStepOneFormModel({
            //     cliente: dettaglioSimulazione.idAdministrativeCategory.toString(),
            //     idAdministration: dettaglioSimulazione.idAdministration,
            //     amministrazioneCensita: dettaglioSimulazione.idAdministration != null,
            //     amministrazioneNonCensita: dettaglioSimulazione.idAdministration == null,
            //     atc: dettaglioSimulazione.idAdministration
            //         ? dettaglioSimulazione.atc
            //         : dettaglioSimulazione.unregisteredAtcName,
            //     dataNascita: moment(dettaglioSimulazione.birthDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ),
            //     nettoMensile:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     pensioneNettaMensile:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     dataAssunzione:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     dataDecorrenza: moment(dettaglioSimulazione.effectiveDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ), //effective
            //     dataPensionamento:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     boxOneRata: FormatUtility.numberWithSeparators(
            //         dettaglioSimulazione.payment.toString(),
            //         0.01
            //     )?.toString(),
            //     boxOneDurata: dettaglioSimulazione.duration,
            //     canale: dettaglioSimulazione.idChannel.toString(),
            //     segmento: dettaglioSimulazione.idSegment.toString(),
            //     fonte: dettaglioPreventivo.sourceType.toString(),
            //     dettaglioFonte: dettaglioPreventivo.sourceDetail,
            //     agente: dettaglioSimulazione.idAgent.toString(),
            //     tipologiaPratica: resumedSimulazione.idPracticeType
            //         ? resumedSimulazione.idPracticeType?.toString()
            //         : environment.defaultIdPracticeType,
            // });

            const step2FormValues = new SimulazioneStepTwoFormModel({
                ...formValuesStep2,
                nome: dettaglioSimulazione.name,
                convenzione: resumedSimulazione.idConvention.toString(),
                fasciaSottoLivelli: resumedSimulazione.idSubLevel
                    ? resumedSimulazione.idSubLevel?.toString()
                    : environment.defaultIdSubLevel,
            });

            const existingExtinctions = FormatUtility.numberWithSeparators(
                dettaglioPreventivo.existingExtinctions,
                0.01
            )?.toString();

            const step3FormValues = new SimulazioneStepThreeFormModel({
                name: dettaglioPreventivo.firstName,
                surname: dettaglioPreventivo.lastName,
                sex: dettaglioPreventivo.gender,
                birthNation: dettaglioPreventivo.birthNation,
                birthPlace: dettaglioPreventivo.birthPlaceCode,
                birthForeignPlace: dettaglioPreventivo.birthPlace,
                // birthCounty: dettaglioPreventivo.birthCounty,
                birthDate: dettaglioPreventivo.birthDate,
                taxCode: dettaglioPreventivo.fiscalCode,
                // residenceNation: dettaglioPreventivo.residenceNation,
                residenceNation: "Z000", //TODO: use the correct value (above line) when the field is added on the DB
                residencePlace: dettaglioPreventivo.residencePlaceCode,
                // residenceCounty: dettaglioPreventivo.residenceCounty,
                residenceAddress: dettaglioPreventivo.residenceAddress,
                residenceCivicNumber: dettaglioPreventivo.residenceCivicNumber,
                mobileNumber: dettaglioPreventivo.mobilePhone,
                email: dettaglioPreventivo.mail,
                existingExtinctions: existingExtinctions,
                thirdPartiesYearExtinctions: dettaglioPreventivo.thirdPartiesYearExtinctions === true ? "1" : "2",
                existingAssignment: dettaglioPreventivo.existingAssignment,
                residenceAddressType: dettaglioPreventivo.residenceAddressType,
                idEstimate: Number(dettaglioPreventivo.idEstimate),
            });

            const simulazione = new SimulazioneModel({
                idSimulation: dettaglioSimulazione.id,
                idProduct: dettaglioSimulazione.idProduct,
                idInsuranceRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurance,
                idInsurancePriceListRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurancePriceList,
                idInsuranceRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurance,
                idInsurancePriceListRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurancePriceList,
                idRequestType: dettaglioSimulazione.idRequestedType,
            });

            const simulateRequest: ISimulateRequest = {
                idProduct: dettaglioPreventivo.idProduct,
                idRequestedType: dettaglioPreventivo.idRequestType,
                idChannel: dettaglioPreventivo.idChannel,
                idSegment: dettaglioPreventivo.idSegment,
                idAgent: dettaglioPreventivo.idAgent,
                idAdministrativeCategory: dettaglioPreventivo.idAdministrativeCategory,
                instalment: dettaglioPreventivo.installment,
                duration: dettaglioPreventivo.duration,
                birthDate: dettaglioPreventivo.birthDate,
                hiringDate: dettaglioSimulazione.hiringDate,
                amount: resumedSimulazione.amount,
                simulationRequestType: 0,
                idConvention: resumedSimulazione.idConvention,
                idSubLevel: resumedSimulazione.idSubLevel,
                idPracticeType: resumedSimulazione.idPracticeType,
            };

            await this.props.dispatch(SimulazioneAction.setFormStep1(step1FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep2(step2FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep3(step3FormValues));
            await this.props.dispatch(SimulazioneAction.setSimulazioneSalvata(simulazione));
            await this.props.dispatch(SimulazioneAction.simulate(simulateRequest));

            await this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    Number(dettaglioSimulazione.idChannel),
                    Number(dettaglioSimulazione.idAgent)
                )
            );

            await this.props.dispatch(
                SimulazioneAction.prodottiLightGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    dettaglioSimulazione.idSegment.toString()!,
                    Number(dettaglioSimulazione.idAgent)
                )
            );
            await this.props.dispatch(LookUpAction.comuniGetBirthPlace(""));
            await this.props.dispatch(LookUpAction.comuniGetResidencePlace(""));
            this.redirectToPageByReqType(dettaglioPreventivo.requestType!);
            await this.props.dispatch(SimulazioneAction.setStep(1));
            await this.props.dispatch(SimulazioneAction.setStep(2));
        }
    };

    private handleSimulazioneRedirect = async () => {
        const { formValuesStep2, dettaglioSimulazione, canali, resumedSimulazione } = this.props;

        if (dettaglioSimulazione && resumedSimulazione) {
            const step1FormValues = StepsUtility.setStep1FormValues(dettaglioSimulazione, resumedSimulazione, canali);
            // const step1FormValues = new SimulazioneStepOneFormModel({
            //     cliente: dettaglioSimulazione.idAdministrativeCategory.toString(),
            //     idAdministration: dettaglioSimulazione.idAdministration,
            //     amministrazioneCensita: dettaglioSimulazione.idAdministration != null,
            //     amministrazioneNonCensita: dettaglioSimulazione.idAdministration == null,
            //     atc: dettaglioSimulazione.idAdministration
            //         ? dettaglioSimulazione.atc
            //         : dettaglioSimulazione.unregisteredAtcName,
            //     dataNascita: moment(dettaglioSimulazione.birthDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ),
            //     nettoMensile:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     pensioneNettaMensile:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     dataAssunzione:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     dataDecorrenza: moment(dettaglioSimulazione.effectiveDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ), //effective
            //     dataPensionamento:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     boxOneRata: FormatUtility.numberWithSeparators(
            //         dettaglioSimulazione.payment.toString(),
            //         0.01
            //     )?.toString(),
            //     boxOneDurata: dettaglioSimulazione.duration,
            //     canale: dettaglioSimulazione.idChannel.toString(),
            //     segmento: dettaglioSimulazione.idSegment.toString(),
            //     agente: dettaglioSimulazione.idAgent.toString(),
            //     tipologiaPratica: resumedSimulazione.idPracticeType
            //         ? resumedSimulazione.idPracticeType?.toString()
            //         : environment.defaultIdPracticeType,
            // });

            const step2FormValues = new SimulazioneStepTwoFormModel({
                ...formValuesStep2,
                nome: dettaglioSimulazione.name,
                convenzione: resumedSimulazione.idConvention.toString(),
                fasciaSottoLivelli: resumedSimulazione.idSubLevel
                    ? resumedSimulazione.idSubLevel?.toString()
                    : environment.defaultIdSubLevel,
            });

            const simulazione = new SimulazioneModel({
                idSimulation: dettaglioSimulazione.id,
                idProduct: dettaglioSimulazione.idProduct,
                idInsuranceRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurance,
                idInsurancePriceListRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurancePriceList,
                idInsuranceRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurance,
                idInsurancePriceListRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurancePriceList,
                idRequestType: dettaglioSimulazione.idRequestedType,
            });

            await this.props.dispatch(SimulazioneAction.setFormStep1(step1FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep2(step2FormValues));
            await this.props.dispatch(SimulazioneAction.setSimulazioneSalvata(simulazione));

            await this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    Number(dettaglioSimulazione.idChannel),
                    Number(dettaglioSimulazione.idAgent)
                )
            );

            await this.props.dispatch(
                SimulazioneAction.prodottiLightGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    dettaglioSimulazione.idSegment.toString()!,
                    Number(dettaglioSimulazione.idAgent)
                )
            );
            this.redirectToPageByReqType(dettaglioSimulazione.requestType!);
            await this.props.dispatch(SimulazioneAction.setStep(1));
            await this.removeLoader();
        }
    };

    private redirectToPageByReqType = async (requestType: string) => {
        switch (requestType) {
            case "CQP":
                NavigationUtility.redirectToPage(RouteEnum.CQP);
                break;
            case "CQS":
                NavigationUtility.redirectToPage(RouteEnum.CQS);
                break;
            case "DLG":
                NavigationUtility.redirectToPage(RouteEnum.DLG);
                break;
        }
    };

    private onBlurHandler = () => {
        this.props.dispatch(ConfigAction.setSearchOnFocus(false));
    };

    private onFocusHandler = () => {
        this.props.dispatch(ConfigAction.setSearchOnFocus(true));
    };

    private onInputChangeHandlerAutocomplete = async (name: string, value: BaseHeaderOptionModel) => {
        const request: CercaHeaderRequest = {
            searchText: String(value),
        };

        await this.props.dispatch(CercaHeaderAction.setForm(value));

        String(value)?.length > 2 && (await this.props.dispatch(CercaHeaderAction.search(request)));
    };

    private onPaginate = async () => {
        const request: CercaHeaderRequest = {
            searchText: "",
            totRecords: 3,
        };

        // await this.props.dispatch(CercaHeaderAction.search(request));
        await NavigationUtility.redirectToPage(RouteEnum.RISULTATI);
    };

    public render(): JSX.Element | null {
        const { isLogged, form, searchHeader, embeddedMode } = this.props;

        const { isNavigating } = this.state;

        // if (isLogged === false || NavigationUtility.checkIfIsSidePage(pathname) === true) {
        //     return <></>;
        // }
        let options: any;

        if (!embeddedMode) {
            let optionEstimates = searchHeader.estimatesResult.map((item: EstimatesModel) => {
                let items = {
                    href: item.href,
                    info: {
                        customerName: item.info?.customerName ?? "",
                        customerSurname: item.info?.customerSurname ?? "",
                        fiscalCode: item.info?.fiscalCode ?? "",
                        idEstimate: item.info?.idEstimate ?? undefined,
                        idEstimateRequest: item.info?.idEstimateRequest ?? undefined,
                    },
                } as BaseHeaderOptionModel;

                return items;
            });

            let optionSimulations = searchHeader.simulationsResult.map((item: SimulationsResultModel) => {
                let items = {
                    href: item.href,
                    name: item.name,
                } as BaseHeaderOptionModel;

                return items;
            });

            options =
                optionEstimates.length > 0 ? optionEstimates : optionSimulations.length > 0 ? optionSimulations : [];
        }
        return (
            <>
                {!embeddedMode && (
                    <LoadingIndicator isActive={isNavigating} id="main-header">
                        <Navbar
                            id="main-header"
                            className="ccq-shadow bg-white"
                            variant="light"
                            color="light"
                            fixed="top"
                        >
                            <Navbar.Brand className="border-right mr-0 cq-logo-links">
                                <img src={logoLinks} alt="logo-corpcq" />
                            </Navbar.Brand>
                            <Navbar.Brand className="mr-0">
                                <div className="cq-logo">
                                    <BaseLabel label={"CQSIMULATOR"} labelClassName="h4 font-weight-bold" />
                                </div>
                            </Navbar.Brand>
                            <NavbarBrand className="ml-auto">
                                <BaseHeaderAutoComplete
                                    controlId=""
                                    name="search"
                                    floatingLabel={false}
                                    placeholder="Cerca..."
                                    value={
                                        form?.name
                                            ? form?.name
                                            : form?.info !== undefined
                                            ? form?.info?.customerName ||
                                              form?.info?.customerSurname ||
                                              form.info?.fiscalCode ||
                                              ""
                                            : ""
                                    }
                                    required={false}
                                    minLength={3}
                                    searchInside={true}
                                    className="search-header-width"
                                    options={FormatUtility.getOptionValuesFromLookupBaseHeader(options)}
                                    onChangeHandler={this.onChangeHandler}
                                    onInputChangeHandler={this.onInputChangeHandlerAutocomplete}
                                    onFocusHandler={this.onFocusHandler}
                                    onBlurHandler={this.onBlurHandler}
                                    isInvalid={false}
                                    maxResults={6}
                                    onPaginate={this.onPaginate}
                                    error={""}
                                />
                            </NavbarBrand>

                            <span className="ml-auto d-flex">
                                {isLogged === true && (
                                    <>
                                        <HeaderNote />
                                        <HeaderNotifiche />
                                    </>
                                )}
                            </span>

                            <Navbar.Brand className="border-right mr-0">
                                <img src={logoBanca} width="150" height="50" className="mx-3" alt="logo-corpcq" />
                            </Navbar.Brand>

                            <HeaderUtente />
                        </Navbar>
                    </LoadingIndicator>
                )}
            </>
        );
    }
}

export { Header as Unconnected };
export default connect(mapStateToProps)(Header);
